import { fg } from '@atlaskit/platform-feature-flags';

// https://switcheroo.atlassian.com/ui/gates/6eab30ba-7a4d-456d-988a-2cd59bb9f4b1/key/is_customer_org_owners_enabled_in_ui
export default {
	get(): boolean {
		return fg('is_customer_org_owners_enabled_in_ui');
	},
};
